import { render, staticRenderFns } from "./pricingPackages.vue?vue&type=template&id=88d534a2&scoped=true&"
import script from "./pricingPackages.vue?vue&type=script&lang=js&"
export * from "./pricingPackages.vue?vue&type=script&lang=js&"
import style0 from "./pricingPackages.vue?vue&type=style&index=0&id=88d534a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d534a2",
  null
  
)

export default component.exports